import { Collection } from '@/state/Collection';
import { _TENANT } from "@/state";
import { ModelDefaults } from "@/state/ModelDefaults";
import { SprintRoutes } from '@/repository/resources';
const { GetAllSprints, GetSprint, CreateSprint, UpdateSprint, ReplicateSprint, DeleteSprint, ShowReport, ShowUserReport, DownloadReport } = SprintRoutes;

// Export this module
export default {
	namespaced: true,
	state: {
		all: Collection.stateDefaults(),
		_all: new Collection({ statePath: 'sprints.all', autoSortRule: { key: 'time_start', asc: true } })
	},
	actions: {

		async index({ commit }, { tenant, game, sprint } = {}) {
			try {
				let res = !!game.id ? await GetAllSprints({ tenant, game, sprint }) : { data: [] }
				commit('SET_SPRINTS_LIST', res.data);
				return res.data
			}
			catch (error) {
				console.error('Sprints could not be indexed.', error);
				throw error;
			}
		},

		async show({ }, { id } = {}) {
			try {
				let res = await GetSprint({ sprint: id });
				return res.data
			}
			catch (error) {
				console.error('Sprint could not be shown.', error);
				throw error;
			}
		},

		async createOrUpdate({ commit }, { sprint, gameId = null }) {
			try {
				let res = {}
				if (sprint.id) {
					res = await UpdateSprint({ sprint });
					commit('UPDATE_SPRINT', res.data)
				}
				else {
					res = await CreateSprint({ sprint, game: gameId });
					commit('APPEND_SINGLE_SPRINT_TO_LIST', res.data)
				}
				return res || {}
			}
			catch (error) {
				console.error('Sprint could not be created/updated.', error);
				throw error;
			}
		},

		async replicate({ commit }, { sprint }) {
			try {
				let res = await ReplicateSprint({ sprint });
				commit('APPEND_SINGLE_SPRINT_TO_LIST', res.data);
				return res;
			} catch (error) {
				console.error('Sprint could not be replicated.', error);
				throw error;
			}
		},

		async delete({ commit }, { sprint }) {
			try {
				let res = await DeleteSprint({ sprint });
				if (res.status !== 204) {
					throw 'Problem occurred when deleting sprint.';
				}
				commit('DELETE_SPRINT', sprint)
				return true;
			}
			catch (error) {
				console.error('Sprint could not be deleted.', error);
				throw error;
			}
		},

		async showReport({ commit }, data) {
			if (_TENANT().blocked_apps.includes('reports')) return;
			try {
				let res = await ShowReport({ data });
				return res.data;
			} catch (error) {
				console.error('Cannot get reports.', error);
				throw error;
			}
		},

		async showUserReport({ commit }, data) {
			if (_TENANT().blocked_apps.includes('reports')) return;
			try {
				let res = await ShowUserReport({ data });
				return res.data;
			} catch (error) {
				console.error('Cannot get reports.', error);
				throw error;
			}
		},

		async downloadReport({ commit }, data) {
			if (_TENANT().blocked_apps.includes('reports')) return;
			try {
				let res = await DownloadReport({ data });
				return res;
			} catch (error) {
				console.error('Cannot get reports.', error);
				throw error;
			}
		},

		async showEmpty({ }) {
			return await ModelDefaults.Sprint()
		}

	},
	mutations: {
		SET_SPRINTS_LIST(state, data) {
			state._all.items.set(data).commitToState()
			this.commit('games/SET_GAME_SPRINTS', state.all.items);
		},
		async APPEND_SINGLE_SPRINT_TO_LIST(state, obj) {
			await this.dispatch('sprints/index', { game: { id: obj.game_id } })
			state._all.items.append(obj).commitToState();
			this.commit('games/SET_GAME_SPRINTS', state.all.items);
		},
		async UPDATE_SPRINT(state, obj) {
			state._all.items.updateItem(obj).commitToState();
			(!state.all.items.length ? await this.dispatch('sprints/index', { game: { id: obj.game_id } }) : null)
			this.commit('games/SET_GAME_SPRINTS', state.all.items);
		},
		async DELETE_SPRINT(state, obj) {
			state._all.items.deleteItem(obj).commitToState();
			(!state.all.items.length ? await this.dispatch('sprints/index', { game: { id: obj.game_id } }) : null)
			this.commit('games/SET_GAME_SPRINTS', state.all.items);
		},
		CLEAR_SPRINTS_LIST(state) {
			state._all.items.set([]).commitToState()
		},
	}
}